import React from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope, faLocationDot, faPhone} from "@fortawesome/free-solid-svg-icons";
import {useOutletContext} from "react-router-dom";

const Contact = () => {
    const { openModal } = useOutletContext();

    const renderBanner = () => (
        <div className="bg-secondary position-relative" style={{ overflow: "hidden" }}>
            <img
                src="https://res.cloudinary.com/dbirahuue/image/upload/v1759158412/ContactImg_zsipcp.webp"
                className="img-fluid w-100"
                alt="Banner"
                style={{
                    maxHeight: "600px",
                    objectFit: "cover",
                    width: "100%",
                    mixBlendMode: "multiply",
                }}
            />
            <div
                className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
            >
                {/* Large screens */}
                <h2 className="d-none d-lg-block text-white text-center text-uppercase p-2 bg-secondary bg-opacity-50" data-aos="zoom-in" style={{letterSpacing: "5px"}}>Contact Us</h2>
                <h5 className="d-none d-lg-block text-white text-center text-uppercase" data-aos="zoom-in" style={{letterSpacing: "10px"}}>Reach out to explore more.</h5>

                {/* Small/medium screens */}
                <h4 className="d-block d-lg-none p-2 mx-3 text-white text-center text-uppercase bg-secondary bg-opacity-50" data-aos="zoom-in" style={{letterSpacing: "5px"}}>Contact Us</h4>
                <h6 className="d-block d-lg-none text-white text-center text-uppercase" data-aos="zoom-in" style={{letterSpacing: "5px"}}>Reach out to explore more.</h6>
            </div>
        </div>
    );

    const renderInfo = () => {
        return (
            <div className="p-4">
                <div className=" text-center mb-2">
                    <h4>Feel Free to contact us</h4>
                    <p className="text-secondary">We are always ready to assist you. Reach out for
                        inquiries, support, or collaboration.</p>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center align-items-center">
                    {/* Address */}
                    <div className="col">
                        <div className="card h-100 shadow-lg border-0 rounded-3 backGround">
                            <div className="card-body text-center">
                                <div className="d-flex justify-content-center align-items-center">
                                    <div className="icon-circle m-0">
                                        <FontAwesomeIcon icon={faLocationDot} />
                                    </div>
                                    <h4 className="brandColor fw-bold ms-2">Address</h4>
                                </div>
                                <p className="mt-2 text-muted">
                                    <span>D-704, Silver-9 CHS, Opp Nageshwar Petrol Pump, Behind D-Mart, Borhadewadi, Moshi, Pune-412105</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Number */}
                    <div className="col">
                        <div className="card h-100 shadow-lg border-0 rounded-3 backGround">
                            <div className="card-body text-center">
                                <div className="d-flex justify-content-center align-items-center">
                                    <div className="icon-circle m-0">
                                        <FontAwesomeIcon icon={faPhone} />
                                    </div>
                                    <h5 className="brandColor fw-bold ms-2">Get In Touch</h5>
                                </div>
                                <p className="mt-2 mb-0">
                                    <a href="tel:+919356579987" className="text-muted text-decoration-none">
                                        +91 93565 79987
                                    </a>
                                </p>
                                <p className="invisible">
                                    <a href="tel:+919766826325" className="text-dark text-decoration-none">
                                        +91 97668 26325
                                    </a>
                                </p>
                            </div>

                        </div>
                    </div>

                    {/* Email */}
                    <div className="col">
                        <div className="card h-100 shadow-lg border-0 rounded-3 backGround">
                            <div className="card-body text-center">
                                <div className="d-flex justify-content-center align-items-center">
                                    <div className="icon-circle m-0">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </div>
                                    <h5 className="brandColor fw-bold ms-2">Email</h5>
                                </div>
                                <p className="mt-2 mb-0">
                                    <a href="mailto:info@vibhaenterprises.co.in" className="text-muted text-decoration-none">
                                        info@vibhaenterprises.co.in
                                    </a>
                                </p>
                                <p className="invisible">
                                    <a href="mailto:info@vibhaenterprises.co.in" className="text-dark text-decoration-none">
                                        info@vibhaenterprises.co.in
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderMap = ({openModal}) => {
        return (
            <div
                className="d-block d-md-flex d-lg-flex justify-content-center align-items-stretch pb-2"
                style={{ minHeight: "350px" }} // keeps a good base height
            >
                {/* Image */}
                <div className="col-12 col-md-6 d-flex bg-secondary position-relative" data-aos="fade-up">
                    <LazyLoadImage
                        src="https://res.cloudinary.com/dbirahuue/image/upload/v1759158952/Image_cwxqje.webp"
                        className="img-fluid w-100 h-100"
                        alt="About Vibha Enterprises"
                        style={{ objectFit: "cover", mixBlendMode: "multiply" }} // fills container nicely
                    />
                    <div className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100">
                        {/* Large screens */}
                        <h4
                            className="d-none d-lg-block text-white text-center mx-2 p-2 bg-secondary bg-opacity-50"
                            data-aos="zoom-in"
                        >
                            Let’s Build Strong Connections
                        </h4>
                        <h6
                            className="d-none d-lg-block text-white text-center"
                            data-aos="zoom-in"
                            style={{ letterSpacing: "5px" }}
                        >
                            Your Trusted Fastening Partner
                        </h6>

                        {/* Small/medium screens */}
                        <h4
                            className="d-block d-lg-none text-white text-center p-2 bg-secondary bg-opacity-50"
                            data-aos="zoom-in"
                        >
                            Let’s Build Strong Connections
                        </h4>
                        <h6
                            className="d-block d-lg-none text-white text-center"
                            data-aos="zoom-in"
                            style={{ letterSpacing: "5px" }}
                        >
                            Your Trusted Fastening Partner
                        </h6>
                        <button
                            type="button"
                            className="btn btn-brand"
                            onClick={() => {
                                openModal("Request a Callback", "form-callback");
                            }}
                            data-aos="fade-up"
                        >
                            Request a Callback
                        </button>
                    </div>
                </div>

                {/* Map */}
                <div className="col-12 col-md-6 d-flex"  data-aos="fade-up">
                    <div className="ratio ratio-16x9">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3779.5455614710077!2d73.83603947465593!3d18.68437776415119!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b7d0b4145215%3A0x39f93b5a9e0837cc!2sVibha%20Enterprises!5e0!3m2!1sen!2sin!4v1759233260642!5m2!1sen!2sin"
                            className="w-100 h-100"
                            style={{ border: 0, minHeight: "100%" }} // ✅ ensures same height as image
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Google Maps Location of Vibha Enterprises"
                        ></iframe>
                    </div>
                </div>
            </div>
        );
    };


    return (
        <div className="container-fluid p-0">
            {renderBanner()}
            {renderInfo()}
            {renderMap({openModal})}
        </div>
    );
}

export default Contact;